import {GET, POST} from "./api.js"; 

export const translations = {
    translations:() => GET(`/translations`),
}